import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

export const ADVANCED_REPORTING_QUERY_KEY = 'advancedReportingKey';

export const useAutomationTemplateIframeUrl = ({
	enabled = true,
	templateId,
	gcTime,
}: {
	enabled?: boolean;
	templateId: string;
	gcTime?: number;
}) => {
	const userSession = useUserSession();
	return useQuery({
		gcTime,
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResult<string>>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `automationTemplate/${templateId}/advancedReportingUrl`,
				}),
				'GET'
			);
		},
		queryKey: [ADVANCED_REPORTING_QUERY_KEY, templateId],
	});
};

export const invalidateTemplateIframeUrl = () => {
	reactQueryClient.invalidateQueries({ queryKey: [ADVANCED_REPORTING_QUERY_KEY] });
};
